import styled from 'styled-components/macro';
import { MiniButton } from '@yme/atoms/mini-button';
import { ADAPTIVE } from '@yme/tokens/screen';
import { boxStyled } from './components/FilterResults/styled';
export const SortOrderStyled = styled.div `
  flex-grow: 1;

  ${ADAPTIVE.minWidth.desktop} {
    width: 230px;

    ${({ hasFilters }) => !hasFilters && 'flex-basis: 50%;'}
  }
`;
export const FiltersButtonStyled = styled(MiniButton) `
  /* TODO: update props configuration for MiniButton: */
  /* https://www.figma.com/file/1AvCVJdBZRAVYsB5H0vFkC/YME-Design-System?type=design&node-id=1135-38865&t=Vui5i3nG53IH7Vbf-0 */
  ${boxStyled}
  white-space: nowrap;
`;
